import { Loading } from 'element-ui'
let loading = null
const showLoading = (params) => {
  if(loading) {
    loading.close()
  }
  let options = {
    // fullscreen: false,
    target: document.querySelector('#mainLoad'),
    lock: true,
    text: '结果下载数据量较大，请耐心等待......',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.5)'
  }
  Object.assign(
    options,
    params
  )
  loading = Loading.service(options)
}
const hideLoading = () => {
  loading.close()
}
export {
  showLoading,
  hideLoading
}




// WEBPACK FOOTER //
// ./src/views/user/children/loading.js